module.exports = __webpack_public_path__ + "static/media/data-contracts-image.a72cfee4.webp";